export function createFormData(data: Record<string, any>): FormData {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (value.every((item) => item instanceof File)) {
        // Array of files → file0, file1, ...
        value.forEach((file, index) => {
          formData.append(`${key}${index}`, file);
        });
      } else if (value.every((item) => typeof item === 'number')) {
        // Array of numbers → "1,2,3"
        formData.append(key, value.join(','));
      } else {
        // Generic arrays → store as JSON
        formData.append(key, JSON.stringify(value));
      }
    } else if (value instanceof File) {
      // Single file
      formData.append(key, value);
    } else if (typeof value === 'boolean') {
      // Boolean → string
      formData.append(key, value.toString());
    } else if (value !== null && value !== undefined) {
      // Everything else
      formData.append(key, value);
    }
  });

  return formData;
}
